(() => {
  const productsSelect = document.querySelectorAll('.productSelect__checkbox');
  if (productsSelect.length) {
    const productQuantityElement = document.querySelector(
      '.cart.variations_form'
    );
    const productQuantityCount =
      +productQuantityElement.dataset.productquantity;
    const priceElement = productQuantityElement.querySelector('.price');
    const priceElementHeader = document.querySelector(
      '.woocommerce-product-header__price'
    );
    const price = priceElement.dataset.promotion
      ? priceElement.dataset.promotion
      : priceElement.dataset.price;
    const quantityElement = document.querySelector('.input-text.qty.text');

    const inputProducts = document.querySelector('#productsSelected');
    productsSelect.forEach((product) => {
      product.addEventListener('change', function (e) {
        const value = product.value;
        const inputProductsArray = inputProducts.value.split(',');
        const countSelected = document.querySelectorAll(
          '.productSelect__checkbox:checked'
        );
        if (inputProductsArray.includes(value)) {
          const index = inputProductsArray.indexOf(value);
          if (index > -1) {
            inputProductsArray.splice(index, 1);
          }
        } else {
          inputProductsArray.push(value);
        }
        console.log(productQuantityCount);
        const tmp = inputProductsArray.join(',');
        inputProducts.value = tmp;
        const productQuantity = Math.ceil(
          countSelected.length / productQuantityCount
        );
        const tmpLimit =
          number_format(productQuantity * price, 2, ',', ' ') + ' PLN';
        priceElement.innerHTML = tmpLimit;
        priceElementHeader.innerHTML = tmpLimit;
        quantityElement.value = +productQuantity;
      });
    });
  }
})();
